@if (authService.showAlertMessage(parentComponent)) {
  <c-alert
    class="c-alert-message align-items-center pt-1 pb-1"
    fade
    [color]="
      authService.getAlertType(parentComponent) === AuthMessageTypeEnum.FAILURE
        ? 'danger'
        : 'success'
    "
    [dismissible]="dismissible"
    [style.direction]="authService.language.direction"
  >
    @for (message of parentComponent.messages; track message) {
      <div id="alert-message">
        @if (parentComponent.messages.length > 1) {
          <i
            id="warning-icon-bell"
            class="p-1"
            [ngClass]="`${iconsStyle} ${icons.ban}`"
          ></i>
        } @else {
          <i
            id="warning-icon-bell"
            [ngClass]="`${iconsStyle} ${iconSize} ${getAlertIcon(parentComponent)}`"
          ></i>
        }
        <span [innerHTML]="authService.getMessage(message) | translate"></span>
      </div>
    }
  </c-alert>
}
